<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : news.名厨亮灶最新预警
 -->

<template>
  <layer title="最新预警" titleClass="01" width="326px" padding="15px 20px">
    <div class="news-wrap">
      <div class="news-wrap-item" v-for="(item, index) in list" :key="index">
        <el-tooltip effect="dark" :content="item.content" placement="right">
          <p class="p-title">{{item.content}}</p>
        </el-tooltip>
        <p class="p-time">{{item.occurrenceTime}}</p>
      </div>
      <div class="no-the-data" v-if="list && list.length===0">
        <div>
          <i class="iconfont icon-content-likes dzi"></i>
          <p>暂无最新预警</p>
        </div>
      </div>
    </div>
  </layer>
</template>

<script>
  export default {
    name: 'news',
    data () {
      return {
        departmentId: '',
        list: [],
        page: 1,
        pageSize: 3
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getNews()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getNews()
      }
      this.newsWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      newsWsMsg () {
        window.getNewsInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getNews()
        }
      },
      /**
       * @Description:获取名厨亮灶最新预警
       * @author wanghongling
       * @createDate 2020/12/24
      */
      getNews() {
        let params = {
          departmentId: this.departmentId,
          page: this.page,
          pageSize: this.pageSize
        }
        this.list = []
        this.$request.exceptionNewDeptListGet(params).then(res => {
          console.log('获取名厨亮灶最新预警', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.list = res
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .news-wrap{
    margin-top: 7px;
    height: 160px;
    &-item{
      margin-bottom: 20px;
      font-size: 14px;
      color: #00fffc;
      &:last-child{
        margin-bottom: 0;
      }
      .p-title{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .p-time{
        margin-top: 3px;
        font-size: 12px;
        color: #83adbb;
      }
    }
    .no-the-data{
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mingChu/news.vue